import { render, staticRenderFns } from "./BaseAccordion.vue?vue&type=template&id=64a566e8&scoped=true&"
import script from "./BaseAccordion.vue?vue&type=script&lang=js&"
export * from "./BaseAccordion.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccordion.vue?vue&type=style&index=0&id=64a566e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a566e8",
  null
  
)

export default component.exports